import React, { useState } from 'react';
import { Button } from '../Button';
import { BriefcaseIcon, EditIcon, DeleteIcon, PlusIcon } from './DashboardIcons';

interface Job {
  id: number;
  title: string;
  location: string;
  type: 'Jornada Completa' | 'Colaborador' | 'Media Jornada';
  description: string;
}

const initialJobs: Job[] = [
    { id: 1, title: `Abogado/a Especialista en Tráfico`, location: `Andorra / Remoto`, type: "Jornada Completa", description: `Buscamos un abogado/a con experiencia en derecho administrativo...` },
    { id: 2, title: `Perito Reconstructor de Accidentes`, location: `Madrid, España`, type: "Colaborador", description: `Necesitamos peritos titulados y con experiencia...` },
    { id: 3, title: `Agente de Atención al Cliente (Multilingüe)`, location: `Remoto`, type: "Jornada Completa", description: `Únete a nuestro equipo de soporte para ser el primer punto de contacto...` },
];

const emptyJob: Job = { id: 0, title: ``, location: ``, type: 'Jornada Completa', description: `` };

export const JobsView: React.FC = () => {
    const [jobs, setJobs] = useState<Job[]>(initialJobs);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [editingJob, setEditingJob] = useState<Job | null>(null);

    const handleOpenForm = (job: Job | null = null) => {
        setEditingJob(job ? { ...job } : { ...emptyJob, id: Date.now() });
        setIsFormOpen(true);
    };

    const handleCloseForm = () => {
        setIsFormOpen(false);
        setEditingJob(null);
    };

    const handleSave = () => {
        if (!editingJob) return;

        if (jobs.some(j => j.id === editingJob.id)) {
            setJobs(jobs.map(j => j.id === editingJob.id ? editingJob : j));
        } else {
            setJobs([...jobs, editingJob]);
        }
        handleCloseForm();
    };

    const handleDelete = (id: number) => {
        if (window.confirm('¿Estás seguro de que quieres eliminar esta oferta de trabajo?')) {
            setJobs(jobs.filter(j => j.id !== id));
        }
    };
    
    return (
        <div className="p-8 bg-white rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800 flex items-center"><BriefcaseIcon /><span className="ml-2">Gestión de Ofertas de Trabajo</span></h1>
                <Button onClick={() => handleOpenForm()} variant="primary" className="bg-blue-600 hover:bg-blue-700 text-white">
                    <span className="flex items-center"><PlusIcon /><span className="ml-2">Añadir Oferta</span></span>
                </Button>
            </div>

            {isFormOpen && editingJob && (
                <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200">
                    <h2 className="text-xl font-semibold mb-4">{editingJob.id === 0 ? 'Nueva Oferta' : 'Editando Oferta'}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <input type="text" placeholder="Título del puesto" value={editingJob.title} onChange={e => setEditingJob({...editingJob, title: e.target.value})} className="w-full p-2 border rounded md:col-span-2" />
                        <select value={editingJob.type} onChange={e => setEditingJob({...editingJob, type: e.target.value as Job['type']})} className="w-full p-2 border rounded bg-white">
                            <option>Jornada Completa</option>
                            <option>Colaborador</option>
                            <option>Media Jornada</option>
                        </select>
                        <input type="text" placeholder="Ubicación" value={editingJob.location} onChange={e => setEditingJob({...editingJob, location: e.target.value})} className="w-full p-2 border rounded md:col-span-3" />
                        <textarea placeholder="Descripción del puesto" value={editingJob.description} onChange={e => setEditingJob({...editingJob, description: e.target.value})} className="w-full p-2 border rounded md:col-span-3" rows={4}></textarea>
                    </div>
                    <div className="flex justify-end gap-3 mt-4">
                        <Button onClick={handleCloseForm} variant="outline" className="border-gray-300 text-gray-700 hover:bg-gray-200">Cancelar</Button>
                        <Button onClick={handleSave} variant="success">Guardar Oferta</Button>
                    </div>
                </div>
            )}

            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th className="px-6 py-3">Puesto</th>
                            <th className="px-6 py-3">Ubicación</th>
                            <th className="px-6 py-3">Tipo</th>
                            <th className="px-6 py-3 text-right">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map(job => (
                            <tr key={job.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4 font-medium text-gray-900">{job.title}</td>
                                <td className="px-6 py-4">{job.location}</td>
                                <td className="px-6 py-4">
                                     <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{job.type}</span>
                                </td>
                                <td className="px-6 py-4 text-right">
                                    <div className="flex justify-end space-x-3">
                                        <button onClick={() => handleOpenForm(job)} className="text-yellow-500 hover:text-yellow-700"><EditIcon /></button>
                                        <button onClick={() => handleDelete(job.id)} className="text-red-500 hover:text-red-700"><DeleteIcon /></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};